import React, { useCallback, useContext } from 'react';
import { ContainerComum } from '../styles';
import { moneyFormat } from '~/utils/functions';
import { useDashboard } from '~/pages/Dashboard/hooks/useDashboard';
import { FaRegMoneyBillAlt } from 'react-icons/fa';
import { BsCartPlusFill } from 'react-icons/bs';
import { Link } from 'react-router-dom';
import { FilterContext } from '~/context/filter';
import { nanoid } from 'nanoid';
import { format } from 'date-fns';
import { toast } from 'react-toastify';

export const BodyPagarReceber: React.FC<{ card: any }> = ({ card }) => {
  const { dashboardData } = useDashboard();
  const { AddFilterOrUpdate, RemoveFilter, filtersContexto } =
    useContext(FilterContext);

  const delay = (ms: number): Promise<void> =>
    new Promise((resolve) => setTimeout(resolve, ms));

  const isPagar = card === 'pagar';
  const color = isPagar ? '#CF2A28' : '#2A78E4';
  const label = isPagar ? 'Pago hoje:' : 'Receb. hoje:';
  const Icon =
    card === 'pagar' || card === 'receber' ? FaRegMoneyBillAlt : BsCartPlusFill;
  const arr = isPagar
    ? dashboardData?.contasAPagar
    : dashboardData?.contasAReceber;

  const openToday = arr?.[0]?.val_aberto ?? 0;
  const closeToday = arr?.[0]?.val_quitado ?? 0;
  const codTela = isPagar ? 51 : 46;

  const createFilter = useCallback(
    (
      itens: Array<{
        codCampo: number;
        codTipoDados: number;
        codTipoInfo: number | null;
        desNome: string;
        desValor: string;
        nomeBd: string;
      }>,
    ) => ({
      codTela,
      edit: false,
      flg_pesquisado: false,
      name_card: '',
      cor: '',
      itens: itens.map((item) => ({
        cod_campo: item.codCampo,
        cod_tipo_dados: item.codTipoDados,
        cod_tipo_info: item.codTipoInfo,
        condicao: 0,
        des_nome: item.desNome,
        des_valor: item.desValor,
        expressao_validacao: null,
        index: nanoid(),
        isBlock: false,
        listagem_info: null,
        nome_bd: item.nomeBd,
        tipo_expressao: 0,
      })),
    }),
    [codTela],
  );

  const onClick = useCallback(
    async (tipo: 'hoje' | 'pago-hoje') => {
      await delay(200);

      const tab = document.getElementById(`${codTela}-tab`);
      if (!tab) return;

      const labelTela = isPagar ? 'Contas a Pagar' : 'Contas a Receber';
      const element = Array.from(document.querySelectorAll('h3')).find(
        (el) => el.textContent?.trim() === labelTela,
      );

      if (element) {
        toast.warning('Finalize esta ação para prosseguir');
        return;
      }

      const divPane = document.getElementById(`${codTela}`);
      if (!divPane) return;

      document.body.style.pointerEvents = 'none';

      const camposParaRemover = [12193, 12196, 12197, 13925, 12233];
      const filtrosAtuais = filtersContexto.find((f) => f.codTela === codTela);

      filtrosAtuais?.itens
        .filter((item) => camposParaRemover.includes(item.cod_campo))
        .forEach((filtro) => RemoveFilter(codTela, filtro.index));

      await delay(200);

      const currDate = format(new Date(), 'yyyy-MM-dd');
      const filtros = [];

      if (isPagar) {
        if (tipo === 'hoje') {
          filtros.push(
            createFilter([
              {
                codCampo: 12193,
                codTipoDados: 1,
                codTipoInfo: 1,
                desNome: 'Data do Vencimento',
                desValor: '1',
                nomeBd: 't.dta_vencimento',
              },
              {
                codCampo: 12196,
                codTipoDados: 6,
                codTipoInfo: null,
                desNome: 'Quitado?',
                desValor: 'false',
                nomeBd: 't.flg_quitado',
              },
            ]),
          );
        } else {
          filtros.push(
            createFilter([
              {
                codCampo: 12197,
                codTipoDados: 1,
                codTipoInfo: 1,
                desNome: 'Data da Quitação',
                desValor: '1',
                nomeBd: 't.dta_quitada',
              },
            ]),
          );
        }
      } else if (tipo === 'hoje') {
        filtros.push(
          createFilter([
            {
              codCampo: 13925,
              codTipoDados: 1,
              codTipoInfo: null,
              desNome: 'Data Vencimento',
              desValor: currDate,
              nomeBd: 't.dta_vencimento',
            },
            {
              codCampo: 12233,
              codTipoDados: 6,
              codTipoInfo: null,
              desNome: 'Quitado?',
              desValor: 'false',
              nomeBd: 't.flg_quitado',
            },
          ]),
        );
      } else {
        filtros.push(
          createFilter([
            {
              codCampo: 12197,
              codTipoDados: 1,
              codTipoInfo: 1,
              desNome: 'Data da Quitação',
              desValor: '1',
              nomeBd: 't.dta_quitada',
            },
          ]),
        );
      }

      filtros.forEach(AddFilterOrUpdate);

      const buttonPesquisar = divPane.querySelector<HTMLButtonElement>(
        '[data-testid="botao-pesquisar"]',
      );

      if (buttonPesquisar) {
        await delay(500);
        buttonPesquisar.click();
      }

      await delay(200);
      document.body.style.pointerEvents = 'auto';
    },
    [
      AddFilterOrUpdate,
      RemoveFilter,
      codTela,
      createFilter,
      filtersContexto,
      isPagar,
    ],
  );

  return (
    <ContainerComum>
      <Link
        to={card === 'pagar' ? '/contas-a-pagar' : '/contas-a-receber'}
        onClick={async () => {
          await onClick('hoje');
        }}
        style={{ backgroundColor: 'white', borderRadius: '5px' }}
      >
        <div className="first-content">
          <Icon size={25} color={color} />
          Hoje:
          <strong style={{ color }}>
            R$ {moneyFormat(openToday.toFixed(2))}
          </strong>
        </div>
      </Link>
      <Link
        to={card === 'pagar' ? '/contas-a-pagar' : '/contas-a-receber'}
        onClick={async () => {
          await onClick('pago-hoje');
        }}
        style={{ backgroundColor: 'white', borderRadius: '5px' }}
      >
        <div className="second-content">
          {label}
          <strong>R$ {moneyFormat(closeToday.toFixed(2))}</strong>
        </div>
      </Link>
    </ContainerComum>
  );
};
